import { useForm } from "react-hook-form";
import { InputFormField } from "../../../formfields/InputFormField";
import { QuickAddChildrenProps } from "../common/QuickAddWrapper";
import { FormButtons } from "../../FormButtons";
import { FormHeader } from "../../FormHeader";
import { Project, ProjectFieldLabels, projectsConstants } from "../../../../api/Projects";
import { useQuickAddSubmit } from "../common/useQuickAddHooks";
import { useProjectPersonPermissionsEditForm } from "../../../../ProjectPersonPermissions/ProjectPersonPermissionsEditForm";
import { useProjectFormSchema } from "../../../../Projects/ProjectForm";
import {
  EntityCustomTypeForm,
  useCustomTypeForm,
  useCustomTypeResolver,
} from "../../../../Customization/CustomTypes/generics/useCustomTypeForm";

export const QuickAddProjectForm = ({ onCreate, onCancel, initialValues }: QuickAddChildrenProps<Project>) => {
  const { onSubmit, loading } = useQuickAddSubmit<Project>({
    resource: projectsConstants.resource,
    onCreate: onCreate,
    onCancel: onCancel,
  });
  const ProjectFormSchema = useProjectFormSchema(initialValues, "ADD");

  const { typedResolver } = useCustomTypeResolver<Partial<Project>>(ProjectFormSchema);

  // const { defaultValues, typedFormSchema, processCustomFields, type, setType, types } = useCustomTypeForm({
  //   initialValues: initialValues,
  //   formSchema: ProjectFormSchema,
  //   typeId: initialValues?.customType?.id,
  //   entityType: "Project",
  //   featureFlag: session?.features.enable_project_custom_types,
  // });

  const {
    reset,
    getValues,
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<Partial<Project>>({
    defaultValues: initialValues,
    resolver: typedResolver,
  });

  const { processCustomFields, types } = useCustomTypeForm({
    control,
    reset,
    getValues,
    entityType: "Project",
  });

  const { form: projectPersonPermissionsEditForm } = useProjectPersonPermissionsEditForm({
    id: "projectPersonPermissions",
    errors: errors,
    project: initialValues as Project,
    getProjectPersonPermissions: (values) => {
      setValue("projectPersonPermissions", values);
    },
  });

  return (
    <>
      <FormHeader title={"Add project"} />

      <InputFormField
        id="name"
        label={ProjectFieldLabels.name}
        errors={errors}
        register={register}
        autoFocus={true}
        required={true}
        placeholder="Enter project name..."
      />

      <fieldset>
        <legend className="col-md-offset-2 col-md-10">
          Project access<span style={{ color: "var(--danger)" }}>*</span>
        </legend>
      </fieldset>

      {projectPersonPermissionsEditForm}

      <EntityCustomTypeForm
        entityType="Project"
        types={types}
        control={control}
        setValue={setValue}
        initialValues={initialValues}
        errors={errors}
        entityConstants={projectsConstants}
      />

      <FormButtons
        onClose={onCancel}
        onSubmit={handleSubmit(async (entity) => await onSubmit(processCustomFields(entity)))}
        disabled={isSubmitting}
        errors={errors}
        submitButtonLabel="Create"
        loading={loading}
      />
    </>
  );
};
